module.exports = __webpack_public_path__ + "media/logos/dobry-wzor-laureat-dc4e9865.png";